import React from 'react';
import { useTranslation } from 'react-i18next';
import SelectFilter, { OPTION_ALL } from './SelectFilter';
import { Column, FilterFnOption } from '@tanstack/react-table';

function BooleanFilter({ column }: { column: Column<any> }) {
	const { t } = useTranslation();

	const options = [
		{ value: OPTION_ALL, key: OPTION_ALL, name: t('table.all') },
		{ value: 1, key: 1, name: t('employees.practical_yes') },
		{ value: 0, key: 0, name: t('employees.practical_no') },
	];

	return (
		<SelectFilter
			id={column.id}
			filterValue={column.getFilterValue()}
			setFilter={column.setFilterValue}
			options={options}
		/>
	);
}

export const booleanFilter: FilterFnOption<any> = (row, columnId, filterValue): boolean => {
	if (filterValue === OPTION_ALL) {
		return true;
	}
	const parsedValue = parseInt(row.getValue(columnId) as string, 10);
	const filterValueParsed = parseInt(filterValue as string, 10);
	if (filterValueParsed) {
		return parsedValue > 0;
	}

	return parsedValue === 0;
};
export default BooleanFilter;
